module.exports = __webpack_public_path__ + "img/lobby3.cb6781f2.jpg";